import React from 'react';
import { useSelector } from 'react-redux';
import { getShowChartingOptions } from '@/store-selectors';
import { PIVOT } from '@/components/charting/chartType.constants';
import { Pivot as PivotBase } from '../buttons';
import {
  useDeriveHeadings,
  useDerivePresentation,
  useHandleDisabledPresentationClick,
  useHandlePresentationChange,
} from './hooks';
import { TConnectedButtonsProps } from './types';

export const Pivot: React.FC<TConnectedButtonsProps> = ({
  hideIfDisabled,
  available,
}) => {
  const headings = useDeriveHeadings();
  const handleChange = useHandlePresentationChange(PIVOT);
  const handleDisabledClick = useHandleDisabledPresentationClick(PIVOT);
  const areChartingOptionsShown = useSelector(getShowChartingOptions);
  const presentation = useDerivePresentation(headings);

  if (hideIfDisabled && !available) return null;

  const handleClick = available ? handleChange : handleDisabledClick;

  const isActive =
    areChartingOptionsShown && available && presentation === PIVOT;

  return (
    <PivotBase onClick={handleClick} $active={isActive} $static={!available} />
  );
};
